import React, {Fragment, useMemo, useState} from 'react';

import { t } from './common/LocalizationProvider';
import {
  makeStyles,
  Typography,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  List,
  Container,
  Paper,
  Divider,
  Box, IconButton, Button
} from '@material-ui/core';
import {useHistory, useParams} from 'react-router-dom';
import { useEffectAsync } from './reactHelper';
import MainToolbar from './MainToolbar';
import { formatPosition } from './common/formatter';
import { prefixString } from './common/stringUtils';
import {ArrowBack} from "@material-ui/icons";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {useSelector} from "react-redux";
import {cyberStyles} from "./cssShared/cyberTheme";

const useStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(3),
  },
  listItem: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const PositionPage = () => {
  const classes = useStyles();
  const { id } = useParams();
  const history = useHistory();
  const devices = useSelector(state => state.devices.items);

  const [item, setItem] = useState(null)

  const device = useMemo(() => {
    if (!item?.deviceId)
      return null;
    return devices[item.deviceId];
  }, [item]);

  useEffectAsync(async () => {
    if (id) {
      const response = await fetch(`/api/positions?id=${id}`, {
        headers: {
          'Accept': 'application/json'
        },
      });
      if (response.ok) {
        const items = await response.json();
        setItem(items[0]);
      }
    } else {
      setItem({});
    }
  }, [id]);

  const formatKey = (key) => {
    return t(prefixString('position', key)) || t(prefixString('shared', key)) || t((key)) || `${t('sharedAttribute')} "${key}"`;
  };

  const attributesList = () => {
    const combinedList = {
      reportDeviceName: device?.name,
      IMEI: device?.uniqueId,
      deviceModel: device?.model,
      TypeCategory: device?.category,
      userExpirationTime: device?.expiredAt,
      status: device?.status,
      commandConfiguration: device?.configured,
      ...item,
      ...item.attributes
    };
    let list = Object.entries(combinedList).filter(([_, value]) => _ !== 'id' && typeof value !== 'object');
    return list;
  }

  return (
      <div className={classes.pageBackground}>
        <MainToolbar />
        <Container maxWidth='sm' className={classes.root}>
          <Box className={classes.header}>
            <IconButton
                edge="start"
                className={classes.backButton}
                onClick={() => history.goBack()}
                aria-label="back"
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5" component="h1" className={classes.headerTitle}>
              {t('sharedShowDetails')}
            </Typography>
          </Box>

          <Paper className={classes.periodMenuPaper} elevation={0} variant="outlined">
            {item ? (
                <List disablePadding>
                  {attributesList().map(([key, value], index, list) => (
                      <Fragment key={key}>
                        <ListItem className={classes.listItem}>
                          <ListItemText
                              primary={
                                <Typography variant="body2" className={classes.label}>
                                  {formatKey(key)}
                                </Typography>
                              }
                          />
                          <ListItemSecondaryAction>
                            <Typography variant="body1" className={classes.value}>
                              {formatPosition(value, key)}
                            </Typography>
                          </ListItemSecondaryAction>
                        </ListItem>
                        {index < list.length - 1 ? <Divider /> : null}
                      </Fragment>
                  ))}
                </List>
            ) : (
                <Box p={4} textAlign="center">
                  <Typography className={classes.value} style={{textAlign: 'center'}}>Loading...</Typography>
                </Box>
            )}
          </Paper>

          <Box mt={3} display="flex" justifyContent="center">
            <Button
                className={classes.backButton}
                variant="text"
                color="default"
                startIcon={<ArrowBack />}
                onClick={() => history.goBack()}
            >
              {t('sharedBack')}
            </Button>
          </Box>
        </Container>
      </div>
  );
}

export default PositionPage;
